import { render, staticRenderFns } from "./SystemLogItem.vue?vue&type=template&id=2308ba78&scoped=true&"
import script from "./SystemLogItem.vue?vue&type=script&lang=js&"
export * from "./SystemLogItem.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogItem.vue?vue&type=style&index=0&id=2308ba78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308ba78",
  null
  
)

export default component.exports